import { atom, useAtom } from "jotai";
import dataService from "../../../../../../../../../helpers/dataService";
import { toast } from "react-toastify";

const companyDocumentsAtom = atom([]);
const isLoadingDocumentsAtom = atom(false);
const isSyncingDocumentsAtom = atom(false);
const isGeneratingDERAtom = atom(false);

const useCompanyDocuments = () => {
  const [companyDocuments, setCompanyDocuments] = useAtom(companyDocumentsAtom);
  const [isLoadingDocuments, setIsLoadingDocuments] = useAtom(
    isLoadingDocumentsAtom,
  );
  const [isSyncingDocuments, setIsSyncingDocuments] = useAtom(
    isSyncingDocumentsAtom,
  );
  const [isGeneratingDER, setIsGeneratingDER] = useAtom(isGeneratingDERAtom);

  const getCompanyDocuments = (companyId) => {
    setIsLoadingDocuments(true);
    dataService.get(
      `clients/${companyId}/files`,
      setCompanyDocuments,
      (err) => {},
      () => setIsLoadingDocuments(false),
    );
  };

  const syncPublicDocuments = (companyId) => {
    setIsSyncingDocuments(true);
    setIsLoadingDocuments(true);
    return dataService.patch(
      `clients/${companyId}/sync-documents-publics`,
      null,
      () => {
        // Refresh the documents list after sync
        getCompanyDocuments(companyId);
        toast.success("Les documents publics ont été synchronisés avec succès");
      },
      (err) => {
        getCompanyDocuments(companyId);
        toast.error(
          err?.response?.data?.other ||
            "Une erreur est survenue lors de la synchronisation",
        );
      },
      () => {
        setIsSyncingDocuments(false);
      },
    );
  };

  const generateDER = (clientId, denominationClient, date) => {
    setIsGeneratingDER(true);

    const derData = {
      clientId,
      denominationClient,
    };

    if (date) {
      derData.date = date;
    }

    dataService.post(
      `files/generer-der`,
      derData,
      () => {
        toast.success(
          "La génération du DER a été lancée avec succès. Rafraîchissez la liste dans quelques instants.",
        );
      },
      (err) => {
        toast.error(
          err?.other || "Une erreur est survenue lors de la génération du DER",
        );
      },
      () => {
        setIsGeneratingDER(false);
      },
    );
  };

  console.log("companyDocuments", companyDocuments);
  return {
    documentState: {
      isLoadingDocuments,
      companyDocuments,
      isSyncingDocuments,
      isGeneratingDER,
    },
    actions: {
      getCompanyDocuments,
      syncPublicDocuments,
      generateDER,
    },
  };
};

export default useCompanyDocuments;
